import React from "react";
import { Row } from "@tanstack/react-table";
import { Route, Routes } from "react-router-dom";

import { DocumentDTO, UtilityBillByIdDTO } from "api";
import { getFromLocalStorage } from "utils";

import { UtilityBillsPage } from "./page";
import {
  UTILITY_BILL_COMMENTS_VIEW,
  UTILITY_BILL_FORM_VIEW,
  UtilityBill,
  UtilityBillCommentsView,
  UtilityBillFormViewForEdit,
  UtilityBillLoader,
} from "./utility-bill";
import { UTILITY_BILL_ALL_DATAENTRIES_VIEW } from "./utility-bill/utility-bill-allDataEntries-view/consts";

import { UTILITY_BILL_PAGE } from "./consts";
import { DocumentExpandedRow } from "../document-upload/components";

export const UtilityBillsRouter = () => (
  <Routes>
    <Route index element={<UtilityBillsPage />} />
    <Route path={UTILITY_BILL_PAGE.PATH} element={<UtilityBill />}>
      <Route
        path={UTILITY_BILL_FORM_VIEW.PATH}
        element={<UtilityBillLoader Component={UtilityBillFormViewForEdit} />}
      />
      <Route
        path={UTILITY_BILL_COMMENTS_VIEW.PATH}
        element={<UtilityBillLoader Component={UtilityBillCommentsView} />}
      />
      <Route
        path={UTILITY_BILL_ALL_DATAENTRIES_VIEW.PATH}
        element={<UtilityBillLoader Component={DocumentComponent} />}
      />
    </Route>
  </Routes>
);
// UtilityBillLoader passes displayBill (stale-while-loading) as utilityBill.
// We merge it so the header always matches the current document without a one-step lag.
export const DocumentComponent = ({
  utilityBill,
}: {
  utilityBill: UtilityBillByIdDTO;
}) => {
  const stored = getFromLocalStorage("dataEntries");
  const rawRow: Row<DocumentDTO> = stored ? JSON.parse(stored) : {};

  const rowData = rawRow?.original
    ? ({
        ...rawRow,
        original: {
          ...rawRow.original,
          fileName: utilityBill?.filename ?? rawRow.original.fileName,
          id: utilityBill?.documentGuid ?? rawRow.original.id,
        },
        id: utilityBill?.documentGuid ?? rawRow.id,
      } as Row<DocumentDTO>)
    : rawRow;
  return <DocumentExpandedRow row={rowData} />;
};
